import { format } from "date-fns";
import { INoteRowInfo } from "src/@types/note";
import { PatientEngagementContactAttemptResponse } from "src/careflow/engagement-hub/patient-engagement/service/PatientService";
import { formattedDateTimeZone } from "src/utils/dates";

export function mapNotes(notes: INoteRowInfo[], code?: string[]) {
  return notes
    .filter(
      (e) => code?.length === 0 || code?.some((r) => r === e.type )
    )
    .map((i) => {
      return ({
        topic: i?.topic || '',
        author: i?.author || '',
        type: i?.type || '',
        description: i?.text || '',
        date: i?.timestamp ? format(new Date(i?.timestamp), 'MMM dd, yyyy') : "",
        medium: i?.medium || '',
      });
    });
}

export function mapContactAttempts(contactAttempts: PatientEngagementContactAttemptResponse[]) {
  return contactAttempts
    ?.filter((item) => item?.noteId)
    .map((i, index) => ({
      when:
        i?.patientEngagementContactAttemptContactOn && 
          format(new Date(i?.patientEngagementContactAttemptContactOn), 'MMM dd, yyyy hh:mm a'),
      outcome: i?.patientEngagementContactAttemptOutcome,
      type: i?.noteType,
      nextContact: {
        data:
          i?.patientEngagementContactAttemptContactOn &&
          formattedDateTimeZone(i?.patientEngagementContactAttemptNextContactOn),
        last: index === contactAttempts?.length - 1 ? true : false,
      },
      notes: i?.noteText,
    }));
}